import store from 'store'

export function isContinuousModeActive(state = store.getState()) {
  const { isContinuousModeEnabled } = state.tools
  const continuousTools = ['PRODUCT_TOOL', 'OBSTRUCTION_TOOL', 'DOOR_TOOL']
  const isContinuousTool = continuousTools.includes(state.tools.activeTool)

  return isContinuousModeEnabled && isContinuousTool
}
